import * as d3 from 'd3';
import React, {Component} from 'react';

const VDECAY = 0.25;
const BUBBLES = '.bubbles';
const FORCE_STRENGTH = 0.4;

class Bubbles extends Component{
  constructor(props){
    super(props);
    const {size} = props;
    // const [x_center, y_center] = center;
    // console.log('center', center);
    this.width = size[0];
    this.height = size[1];
    //somehow my (0,0) is already at the center? happy bug
    this.simulation = d3.forceSimulation()
                        .velocityDecay(VDECAY)
                        // .alphaTarget(0)
                        .force('x', d3.forceX().strength(FORCE_STRENGTH).x(this.width/2))
                        .force('y', d3.forceY().strength(FORCE_STRENGTH).y(this.height/2))
                        // .force('x', d3.forceX().strength(FORCE_STRENGTH).x(this.width/2))
                        // .force('y', d3.forceY().strength(FORCE_STRENGTH).y(this.height/2))
                        .stop();
                        // .force('x', d3.forceX().strength(FORCE_STRENGTH).x(0))
                        // .force('y', d3.forceY().strength(FORCE_STRENGTH).y(this.height/2))

    this.ref = null;
  }

  state = {g: null};

  componentDidMount(){
    this.setState({g: d3.select(this.ref)});
    this.renderBubbles(this.props.data);
    this.simulation
    .force('charge', d3.forceManyBody().distanceMax(this.width).strength(this.charge.bind(this))) // to scale many body, let's make the sterngth more abstracted
    .on('tick', this.ticked.bind(this))
    // .force('center', d3.forceCenter(this.width/2, this.height/2))
    .stop();
  }

  componentWillReceiveProps(newProps){

    // console.log('NE', newProps);
    if (newProps.data.x !== this.props.data.x){
      this.renderBubbles(newProps.data);
    }
  }

  shouldComponentUpdate(){
    return false;
  }

  ticked(){
    // console.log(    d3.select(this.ref).selectAll('.bubble'));
    this.bubble
      // .attr('vx', d => (d.x <= this.width || d.x >= this.width - d.width) ? -10 : d.vx)
      // .attr('vy', d => (d.y <= this.height || d.y >= this.height - d.height) ? -10: d.vy)
      .attr('x', d => Math.max(d.width, Math.min(this.width - d.width, d.x)))
      .attr('y', d => Math.max(d.height, Math.min(this.height - d.height, d.y)))

  }

  charge(d){
    let charge = (-FORCE_STRENGTH * Math.pow(d.width,1.8)); //0.78, 1.8
    return charge;
  }

  renderBubbles(data){
    // console.log('render data');
    // console.log('REF', d3.select(this.ref).selectAll(BUBBLES));

    if (this.ref.parentNode === null) return;

    // const bubbles = d3.select(this.ref).selectAll('.bubbleg').data(data.sort((a,b) => d3.ascending(a.id, b.id)), d => d.id);
    const bubbles = d3.select(this.ref).selectAll('.bubbleg').data(data.sort((a,b) => a.id.localeCompare(b.id)), d => d.id);


    this.bubble = bubbles.enter().append('svg:image')
                          .classed('bubbleb', true)
                          .attr('xlink:href', d => './emojione/' + d.unicode + '.svg')
                          .attr('x', d => Math.max(d.width, Math.min(this.width - d.width, d.x)))
                          .attr('y', d => Math.max(d.height, Math.min(this.height - d.height, d.y)))
                          .attr('width', d => d.width)
                          .attr('height', d =>  d.height);

    this.bubble.transition()
           .duration(100)
           .attr('x', d => d.x)
           .attr('y', d => d.y)
           .on('end', () => {
             this.simulation.nodes(data).alpha(0.8).restart();
           })
  }

  render(){
    return(<g ref={(ref) => this.ref = ref} className='bubbleg' width={this.width} height={this.height}/>)
  }
}

export default Bubbles;

// Bubbles.propTypes = {
//   center: PropTypes.shape({
//     x: PropTypes.number.isRequired,
//     y: PropTypes.number.isRequired,
//   }),
//   forceStrength: PropTypes.number.isRequired,
//   yearCenters: PropTypes.objectOf(PropTypes.shape({
//     x: PropTypes.number.isRequired,
//     y: PropTypes.number.isRequired,
//   }).isRequired).isRequired,
//   data: PropTypes.arrayOf(PropTypes.shape({
//     x: PropTypes.number.isRequired,
//     y: PropTypes.number.isRequired,
//     id: PropTypes.string.isRequired,
//     radius: PropTypes.number.isRequired,
//     value: PropTypes.number.isRequired,
//     name: PropTypes.string.isRequired,
//   })),
// }



// WEBPACK FOOTER //
// ./src/Charts/BubbleGroup/Bubbles.js